const SET_LACTATION_CURVE_RESULTS = (state, payload) => {
  state.results = payload;
}

export default {
  SET_LACTATION_CURVE_RESULTS
}